/** @format */

import React, { useState, useEffect, useRef } from "react";
import { Modal } from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "../../css/Follow-up.css";

import GiveStarEN from "./GiveStar-EN";

import report_icon from "../../assets/report_icon.png";
import inprogress_icon from "../../assets/inprogress_icon.png";
import finish_icon from "../../assets/finish_icon.png";
import irrelevant_icon from "../../assets/irrelevant_icon.png";
import follow_icon from "../../assets/follow_icon.png";
import please_wait_img from "../../assets/please_wait_img.png";

/////////////   Redux  //////////////
import { useSelector, useDispatch } from "react-redux";
import SecureStorage from "react-secure-storage";

export default function Follow_up_newTH(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const detailReport = JSON.parse(sessionStorage.getItem("detailReport2"));
  const [hasChecked, setHasChecked] = useState(false);
  const [alert_header, setAlertHeader] = useState(); //หัวข้อ alert
  const [alert_content, setAlertContent] = useState(); //รายละเอียก alert
  const [alert_description, setAlertDescription] = useState(); //รายละเอียก alert
  const modal_alert_ref = useRef(); //สำหรับ alert
  const [modal_alert_close, setModalAlertClose] = useState(null); //สำหรับ alert
  const alert_fail = (
    <span class="material-icons text-danger post-alert-icon my-3">cancel</span>
  );

  const constants = require("file-configs/constants");
  const [ticket_id, setTicketId] = useState("");
  const [password, setPassword] = useState("");

  const [status, setStatus] = useState(null);
  const [dataTimeline, setDataTimeline] = useState([]);
  const [selectRating, setSelectRating] = useState(5);
  const [nameOrg, setNameOrg] = useState([]);
  const [problemType, setProblemType] = useState("");
  const [comment, setComment] = useState("");
  const [idMsg, setIdMsg] = useState("");
  const [address, setAddress] = useState("");
  const [star, setStar] = useState(null);
  const [showIconStar, setShowIconStar] = useState("");
  const [showStatusTH, setShowStatusTH] = useState("");
  const [statusManage, setStatusManage] = useState("");
  const [photoOrg, setPhotoOrg] = useState(
    "https://storage.googleapis.com/traffy_public_bucket/dashboard_icon/image_preview.png"
  );
  const [photo, setPhoto] = useState(
    "https://storage.googleapis.com/traffy_public_bucket/dashboard_icon/image_preview.png"
  );
  const [finish_photo, setFinishPhoto] = useState(please_wait_img);

  const [expandedItems, setExpandedItems] = useState([]);
  const [expandedItemsNote, setExpandedItemsNote] = useState([]);

  // useEffect(() => {
  //   if (detailReport && !hasChecked) {
  //     setHasChecked(true);
  //     pushDataTimeline();
  //     setTicketId(detailReport["case"]["ticket_id"]);
  //     setComment(detailReport["case"]["comment"]);
  //     setProblemType(detailReport["case"]["tags"]);
  //     setAddress(detailReport["case"]["address"]);
  //     setPhoto(detailReport["case"]["photo"]);
  //     setStatus(detailReport["case"]["status"]);
  //     const filteredTimeline = detailReport["timeline"].filter(
  //       (item) => item.att_status === "finish" && item.photo !== ""
  //     );
  //     if (filteredTimeline.length != 0) {
  //       setFinishPhoto(filteredTimeline[0]["photo"]);
  //     }
  //   }
  // }, [detailReport]);

  const toggleExpansion = (index) => {
    setExpandedItems((prevItems) => {
      if (prevItems.includes(index)) {
        // ถ้าอินเด็กอยู่ในอาร์เรย์แล้ว (เปิดอยู่) ให้ลบออก
        return prevItems.filter((expandedItem) => expandedItem !== index);
      } else {
        // ถ้าอินเด็กยังไม่อยู่ในอาร์เรย์ (ปิดอยู่) ให้เพิ่มเข้าไป
        return [...prevItems, index];
      }
    });
  };
  useEffect(() => {
    pushDataTimeline();
  }, [expandedItems]);

  async function pushDataTimeline() {
    let timelineAll = [];
    let state_type_in_timeline = {};
    let date_long = "";
    let date_short = "";
    let time = "";
    let timestamp = "";
    let manage_by = {}; // สำหรับแสดงชื่อหน่วยงานใน timeline
    let time_diff = "";
    let timeManageSinceReport = "";

    if (detailReport["timeline"].length != 0) {
      await Promise.all(
        detailReport["timeline"].map(async (v, k) => {
          let note = v["note"];
          let photo = v["photo"];
          let state_color = v["att_status"];
          let state = v["tl_state_name"];

          let updated_on = v["updated_on"];
          let manage_by = v["first_name"];

          if (updated_on != undefined && updated_on != "") {
            timestamp = updated_on;
            let date_time = new Date(v["updated_on"]);

            date_long = date_time.toLocaleDateString("th-TH", {
              year: "2-digit",
              month: "long",
              day: "numeric",
              weekday: "long",
            });
            date_short = date_time.toLocaleDateString("th-TH", {
              year: "2-digit",
              month: "short",
              day: "numeric",
              weekday: "short",
            });
            time = date_time.toLocaleTimeString("th-TH", {
              hour: "numeric",
              minute: "numeric",
            });

            if (detailReport["timeline"].length - 1 != k) {
              let now_time = new Date(v["updated_on"]);
              let prev_time = new Date(
                detailReport["timeline"][parseInt(k) + 1]["updated_on"]
              );
              let dif = (
                (now_time.getTime() - prev_time.getTime()) /
                1000
              ).toFixed(1);

              let timeAll = Math.round(
                (now_time.getTime() - date_time.getTime()) / 1000
              );

              timeManageSinceReport = "หลังรับแจ้ง " + secToHHMMS(timeAll);

              time_diff = "เวลาที่ใช้ดำเนินการ " + secToHHMMS(dif);
            }

            timelineAll.push(
              stateLineTimeline(
                state,
                state_color,
                date_short + " " + time,
                note,
                photo,
                manage_by,
                timeManageSinceReport,
                time_diff,
                k
              )
            );
          }
        })
      );

      setDataTimeline(timelineAll.reverse());
    }
  }

  const stateLineTimeline = (
    state,
    state_color,
    time,
    note,
    photo,
    manage_by,
    timeManageSinceReport,
    time_diff,
    index
  ) => {
    return (
      <div
        style={{ display: "flex", alignItems: "center", position: "relative" }}>
        {index !== 0 && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: "20px",
              width: "8px",
              backgroundColor: "#a0a0a0",
              zIndex: 0,
            }}></div>
        )}

        <div
          onClick={() => toggleExpansion(index)}
          style={{
            backgroundColor: "#f5ebf4",
            width: "100%",
            height: "auto",
            padding: "0.5rem",
            display: "flex",
            flexDirection: "column",
            borderRadius: "9px",
            border: "1px solid var(--Schemes-Outline-Variant, #f5ebf4)",
            marginBottom: index !== 0 ? "1rem" : "4rem",
            position: "relative",
            zIndex: 1,
          }}>
          <div>
            <div
              style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
              <span
                className={
                  "timeline-step-icon color-state-" + state_color
                }></span>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ fontWeight: "600", fontFamily: "Noto Sans Thai" }}>
                  {state}
                </p>
                <p style={{ fontFamily: "Noto Sans Thai" }}>{time}</p>
              </div>

              <svg
                style={{ marginLeft: "auto" }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15L7 10H17L12 15Z" fill="#49454F" />
              </svg>
            </div>
          </div>

          {expandedItems.includes(index) && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {photo && <img src={photo} style={{ marginTop: "1rem" }} />}

              <p style={{ fontFamily: "Noto Sans Thai", marginTop: "1rem" }}>
                {note}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };

  const secToHHMMS = (totalSeconds, from) => {
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds - days * 86400) / 3600);
    var minutes = Math.floor((totalSeconds - days * 86400 - hours * 3600) / 60);
    var seconds = Math.round(
      totalSeconds - days * 86400 - hours * 3600 - minutes * 60
    );

    seconds = Math.round(seconds * 100) / 100;

    var result = "";

    if (from == "talkWithReporter") {
      if (days > 0) {
        result = days + " วัน";
      } else if (hours > 0) {
        result = hours + " ชั่วโมง";
      } else {
        result = minutes + " นาที";
      }
    } else {
      if (days > 0) {
        result += days + " วัน";
      }
      if (hours > 0) {
        result += " " + hours + " ชม.";
      }
      if (minutes) {
        result += " " + minutes + " นาที";
      }
      if (seconds) {
        result += " " + seconds + " วินาที";
      }
    }

    return result;
  };

  const renderTitleTimeline = () => {
    let src = "";
    let message = "";
    if (status == "start" || "report") {
      src = report_icon;
      message = "We received your complaint";
    }
    if (status == "inprogress") {
      src = inprogress_icon;
      message = "We proceeding your complaint";
    }
    if (status == "follow") {
      src = follow_icon;
      message = "Following up fixing process";
    }
    if (status == "finish") {
      src = finish_icon;
      message = "Completed, Thank you for your hand ";
    }
    if (status == "irrelevant") {
      src = irrelevant_icon;
      message = "Irrelevant";
    }

    return (
      <div className="container-title-follow-up">
        <img className="img-inprogress" src={src}></img>
        <p>{message}</p>
      </div>
    );
  };

  const setAlert = async (header_text, icon, description) => {
    setAlertHeader(header_text);
    setAlertContent(icon);
    setAlertDescription(description);
    modalShow(modal_alert_ref, setModalAlertClose);
    // modalShow(modal_preview_ref, setModalPreviewClose);
  };

  const modalShow = (mRef, setModals) => {
    const modal = new Modal(mRef.current, { keyboard: false });
    setModals(modal);
    modal.show();
  };

  return (
    <div className="container-follow-up">
      {/* <div className="container-top-follow-up">{renderTitleTimeline()}</div> */}

      {/* <div className={"container-center-follow-up-" + status}> */}
      {/* <div className="container-ticket-box">
          <p className="ticket">{ticket_id}</p>
        </div> */}
      <div style={{ padding: "1rem" }}>{dataTimeline}</div>
      {/* </div> */}

      {/* <div className="container-bottom-follow-up">
        <div className="container-sub-detail mt-3">
          <p className="sub-title">Ticket ID</p>
          <p className="sub-title-detail">{ticket_id}</p>
        </div>

        <div className="container-sub-detail mt-3">
          <p className="sub-title">Description</p>
          <p className="sub-title-detail">{comment}</p>
        </div>

        <div className="container-sub-detail mt-2">
          <p className="sub-title">Type of Issue</p>
          <p className="sub-title-detail">{problemType}</p>
        </div>

        <div className="container-sub-detail mt-2">
          <p className="sub-title">Location</p>
          <p className="sub-title-detail">{address}</p>
        </div>

        <div className="container-sub-detail-img mt-4">
          <div className="container-sub-detail-img2">
            <p className="sub-title">Before</p>
            <img src={photo} />
          </div>

          <div className="container-sub-detail-img2">
            <p className="sub-title">After</p>
            <img src={finish_photo} />
          </div>
        </div>
      </div>

      {status == "finish" ? <GiveStarEN /> : null} */}
    </div>
  );
}
